/**
 * internal dependencies
 */
import { getTerminals } from '../../routes/get-terminal';
import { displayTerminalList } from './display/display-terminallist';
import { terminalListFilter } from './filters/terminallist-filter';
import { downloadTerminalListData } from './download/terminallist-download';

/**
 * Terminal List Main
 * This function initializes and manages the terminal list table and related functionalities.
 * 
 * @returns void
 */
const TerminalListTable = async (): Promise<void> => {
  const terminalTable = document.querySelector('.aafp_terminal-list') as HTMLElement;
  if(!terminalTable) return;

  const { body } = await getTerminals();

  const tableObject = displayTerminalList(terminalTable, body);
  terminalListFilter(tableObject);
  downloadTerminalListData(tableObject);
};

export default TerminalListTable;